import React from 'react';
import { IconProps } from './types';

export const AvatarIcon = (props: Pick<IconProps, 'size' | 'style'>) => {
  const { size = 48, style = {} } = props;

  return (
    <svg
      width={size}
      height={size + 1}
      style={style}
      viewBox='0 0 48 49'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <circle cx='24' cy='24.5' r='24' fill='#DDDEDB' />
      <g clipPath='url(#clip0_3920_13719)'>
        <path
          d='M11.3242 31.8667C13.2323 31.8667 14.7792 30.4051 14.7792 28.6023C14.7792 26.7994 13.2323 25.3379 11.3242 25.3379C9.416 25.3379 7.86914 26.7994 7.86914 28.6023C7.86914 30.4051 9.416 31.8667 11.3242 31.8667Z'
          fill='url(#paint0_radial_3920_13719)'
        />
        <path
          d='M36.6283 31.8212C34.7051 31.8212 33.1462 30.3632 33.1462 28.5647C33.1462 26.7661 34.7051 25.3081 36.6283 25.3081C38.5514 25.3081 40.1104 26.7661 40.1104 28.5647C40.1104 30.3632 38.5514 31.8212 36.6283 31.8212Z'
          fill='url(#paint1_radial_3920_13719)'
        />
        <path
          d='M24.1552 12.6372C30.6887 12.6372 35.9944 17.9949 35.9944 24.5953V28.7259C35.9944 35.0789 30.8873 40.2373 24.5976 40.2373H23.7142C17.4245 40.2373 12.3174 35.0789 12.3174 28.7259V24.5953C12.3174 17.9962 17.6218 12.6372 24.1565 12.6372H24.1552Z'
          fill='#141517'
        />
        <path
          d='M24.1552 12.6372C30.6887 12.6372 35.9944 17.9949 35.9944 24.5953V28.7259C35.9944 35.0789 30.8873 40.2373 24.5976 40.2373H23.7142C17.4245 40.2373 12.3174 35.0789 12.3174 28.7259V24.5953C12.3174 17.9962 17.6218 12.6372 24.1565 12.6372H24.1552Z'
          fill='url(#paint2_linear_3920_13719)'
        />
        <path
          d='M24.598 40.2363H23.7146C17.4249 40.2363 12.3178 35.0779 12.3178 28.725L12.3178 24.5944C12.3178 17.9953 17.6222 12.6363 24.157 12.6363C30.6904 12.6363 35.9961 17.994 35.9961 24.5944V28.725C35.9961 35.0779 30.889 40.2363 24.5993 40.2363H24.598Z'
          fill='url(#paint3_linear_3920_13719)'
        />
        <path
          d='M24.1552 18.4057C29.573 18.4057 34.2816 21.209 36.6765 25.3292V21.4135C36.6765 14.6711 31.2148 9.15576 24.5408 9.15576H23.7683C17.0942 9.15576 11.6338 14.6711 11.6338 21.4135V25.3292C14.0287 21.2077 18.7373 18.4057 24.1552 18.4057V18.4057Z'
          fill='url(#paint4_radial_3920_13719)'
        />
        <path
          d='M36.8992 25.474C34.4617 21.2795 29.6693 18.4268 24.1547 18.4268C18.6401 18.4268 13.8477 21.2795 11.4102 25.474C11.231 25.7827 11.0646 26.0992 10.9111 26.4223C10.8466 26.5564 11.0259 26.6724 11.1226 26.5591C11.2194 26.4457 11.3122 26.3389 11.4102 26.2321C14.3661 22.9638 18.9754 20.8627 24.1547 20.8627C29.334 20.8627 33.9433 22.9638 36.8992 26.2321C36.9972 26.3415 37.0939 26.4509 37.1894 26.563C37.2848 26.675 37.4641 26.5604 37.3996 26.4262C37.2461 26.1018 37.0798 25.7853 36.8992 25.4753V25.474Z'
          fill='url(#paint5_radial_3920_13719)'
        />
      </g>
      <defs>
        <radialGradient
          id='paint0_radial_3920_13719'
          cx='0'
          cy='0'
          r='1'
          gradientUnits='userSpaceOnUse'
          gradientTransform='translate(12.2372 30.3517) scale(5.74417 5.8019)'
        >
          <stop offset='0.56' stopColor='#000203' />
          <stop offset='0.62' stopColor='#020808' />
          <stop offset='0.7' stopColor='#081B18' />
          <stop offset='0.8' stopColor='#123932' />
          <stop offset='0.91' stopColor='#216356' />
          <stop offset='1' stopColor='#2E8977' />
        </radialGradient>
        <radialGradient
          id='paint1_radial_3920_13719'
          cx='0'
          cy='0'
          r='1'
          gradientUnits='userSpaceOnUse'
          gradientTransform='translate(35.708 30.3099) rotate(180) scale(5.7892 5.78801)'
        >
          <stop offset='0.56' stopColor='#000203' />
          <stop offset='0.62' stopColor='#020808' />
          <stop offset='0.7' stopColor='#081B18' />
          <stop offset='0.8' stopColor='#123932' />
          <stop offset='0.91' stopColor='#216356' />
          <stop offset='1' stopColor='#2E8977' />
        </radialGradient>
        <linearGradient
          id='paint2_linear_3920_13719'
          x1='10.2797'
          y1='27.4533'
          x2='15.9161'
          y2='27.0549'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#2E8977' />
          <stop offset='0.14' stopColor='#2B8271' stopOpacity='0.95' />
          <stop offset='0.32' stopColor='#257062' stopOpacity='0.82' />
          <stop offset='0.54' stopColor='#1C5348' stopOpacity='0.61' />
          <stop offset='0.78' stopColor='#0E2B25' stopOpacity='0.31' />
          <stop offset='1' stopOpacity='0' />
        </linearGradient>
        <linearGradient
          id='paint3_linear_3920_13719'
          x1='38.0325'
          y1='27.4537'
          x2='32.3961'
          y2='27.0552'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#2E8977' />
          <stop offset='0.14' stopColor='#2B8271' stopOpacity='0.95' />
          <stop offset='0.32' stopColor='#257062' stopOpacity='0.82' />
          <stop offset='0.54' stopColor='#1C5348' stopOpacity='0.61' />
          <stop offset='0.78' stopColor='#0E2B25' stopOpacity='0.31' />
          <stop offset='1' stopOpacity='0' />
        </linearGradient>
        <radialGradient
          id='paint4_radial_3920_13719'
          cx='0'
          cy='0'
          r='1'
          gradientUnits='userSpaceOnUse'
          gradientTransform='translate(25.0579 18.4813) scale(15.1484 15.3007)'
        >
          <stop offset='0.38' stopColor='#000203' />
          <stop offset='0.47' stopColor='#020808' />
          <stop offset='0.59' stopColor='#081B18' />
          <stop offset='0.73' stopColor='#123932' />
          <stop offset='0.88' stopColor='#216356' />
          <stop offset='1' stopColor='#2E8977' />
        </radialGradient>
        <radialGradient
          id='paint5_radial_3920_13719'
          cx='0'
          cy='0'
          r='1'
          gradientUnits='userSpaceOnUse'
          gradientTransform='translate(30.3632 39.5905) scale(26.6265 26.894)'
        >
          <stop offset='0.56' stopColor='#000203' />
          <stop offset='0.62' stopColor='#020808' />
          <stop offset='0.7' stopColor='#081B18' />
          <stop offset='0.8' stopColor='#123932' />
          <stop offset='0.91' stopColor='#216356' />
          <stop offset='1' stopColor='#2E8977' />
        </radialGradient>
        <clipPath id='clip0_3920_13719'>
          <rect
            width='32.2623'
            height='31.082'
            fill='white'
            transform='translate(7.86914 9.15576)'
          />
        </clipPath>
      </defs>
    </svg>
  );
};
